import { Box, Container, Typography, styled } from '@mui/material';
import { useStrings } from 'src/utility/useStrings';

const FooterWrapper = styled(Container)(
  ({ theme }) => `
        margin-top: ${theme.spacing(4)};
`
);

function Footer() {
  const { t } = useStrings();
  return (
    <FooterWrapper className="footer-wrapper">
      <Box
        pb={4}
        display={{ xs: 'block', md: 'flex' }}
        alignItems="center"
        textAlign={{ xs: 'center', md: 'left' }}
        justifyContent="space-between"
      >
        <Typography variant="body2">{t('footer.copyright')}</Typography>
      </Box>
    </FooterWrapper>
  );
}

export default Footer;
